import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../config';
import axios from 'axios';
import { toast } from 'sonner';
import Layout from '../components/Layout';
import { Loader2 } from 'lucide-react';

const Register = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/register`, data);
      toast.success("Registration Successful!");
      // Navigate to upload page with registration ID
      navigate(`/upload?id=${response.data.registration_id}`);
    } catch (error) {
      toast.error("Registration failed. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <div className="bg-white p-8 rounded-sm shadow-xl border-t-4 border-primary temple-border">
          <h2 className="text-3xl font-bold text-center mb-2 text-primary">Registration Form</h2>
          <p className="text-center text-muted-foreground mb-8">Join us for the divine experience</p>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            
            {/* Full Name */}
            <div className="space-y-2">
              <label className="text-lg font-serif font-medium">Full Name *</label>
              <input 
                {...register("full_name", { required: "Name is required" })}
                className="w-full border-b-2 border-border focus:border-primary outline-none py-2 text-lg bg-transparent transition-colors placeholder:text-gray-300"
                placeholder="Enter your full name"
              />
              {errors.full_name && <p className="text-primary text-sm">{errors.full_name.message}</p>}
            {/* Experience Level (Optional) */}
            <div className="space-y-2">
              <label className="text-lg font-serif font-medium">Experience Level</label>
              <select 
                {...register("experience_level")}
                className="w-full border-b-2 border-border focus:border-primary outline-none py-2 text-lg bg-transparent transition-colors placeholder:text-gray-300"
              >
                <option value="">Select Level</option>
                <option value="Beginner">Beginner</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advanced">Advanced</option>
              </select>
            </div>

            </div>

            {/* Email */}
            <div className="space-y-2">
              <label className="text-lg font-serif font-medium">Email Address *</label>
              <input 
                type="email"
                {...register("email", { 
                  required: "Email is required",
                  pattern: { value: /^\S+@\S+$/i, message: "Invalid email" }
                })}
                className="w-full border-b-2 border-border focus:border-primary outline-none py-2 text-lg bg-transparent transition-colors placeholder:text-gray-300"
                placeholder="you@example.com"
              />
              {errors.email && <p className="text-primary text-sm">{errors.email.message}</p>}
            </div>

            {/* Phone */}
            <div className="space-y-2">
              <label className="text-lg font-serif font-medium">Phone / WhatsApp *</label>
              <input 
                type="tel"
                {...register("phone", { required: "Phone number is required" })}
                className="w-full border-b-2 border-border focus:border-primary outline-none py-2 text-lg bg-transparent transition-colors placeholder:text-gray-300"
                placeholder="+91 98765 43210"
              />
              {errors.phone && <p className="text-primary text-sm">{errors.phone.message}</p>}
            </div>

            {/* City (Optional) */}
            <div className="space-y-2">
              <label className="text-lg font-serif font-medium">City</label>
              <input 
                {...register("city")}
                className="w-full border-b-2 border-border focus:border-primary outline-none py-2 text-lg bg-transparent transition-colors placeholder:text-gray-300"
                placeholder="Your city"
              />
            </div>

            {/* Consents */}
            <div className="pt-4 space-y-3">
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" {...register("consent_whatsapp")} className="w-5 h-5 accent-primary" />
                <span className="text-muted-foreground">Add me to the Workshop WhatsApp group</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" {...register("consent_email")} className="w-5 h-5 accent-primary" defaultChecked />
                <span className="text-muted-foreground">Receive workshop updates via email</span>
              </label>
            </div>

            {/* Submit */}
            <button 
              type="submit" 
              disabled={loading}
              className="w-full bg-primary text-white py-4 text-xl font-serif rounded shadow hover:bg-primary/90 transition-all mt-8 disabled:opacity-70 flex justify-center items-center gap-2"
            >
              {loading && <Loader2 className="animate-spin" />}
              {loading ? "Registering..." : "Proceed to Payment"}
            </button>

          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
